import React, {useEffect} from 'react';
import {node_env} from "../../../api/API_SERVERS";

export default function PaypalAuth() {
    useEffect(() => {
        const clientId =
            node_env === 'production'
                ? process.env.REACT_APP_PAYPAL_CLIENT_ID_LIVE
                : process.env.REACT_APP_PAYPAL_CLIENT_ID_SANDBOX;

        const script = document.createElement('script');
        script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=USD`;
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return <div id="paypal-button-container"></div>;
};